<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4">
                    <div *ngIf="approvalList?.length;else noApprover">

                    </div>
                    <div *ngFor="let approver of approvalList">
                        <div class="row g-3">
                            <div class="col-md-3">
                                <p>{{approver?.username}}</p>
                                <p>{{approver?.name}}</p>
                            </div>
                            <div class="col-md-6">
                                <p>{{approver?.email}}</p>
                            </div>
                            <div class="col-md-3">
                                <h6>
                                    <span
                                        [ngClass]="approver?.approval_status === 'APPROVED' ? 'badge bg-success' : (approver?.approval_status === 'REJECTED' ? 'badge bg-danger' : 'badge bg-warning')">
                                        {{approver?.approval_status}}</span>
                                </h6>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #noApprover>
    <span>No approver details found</span>
</ng-template>